import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Rail from "./designSystem/c-organism/navigation/rail/Rail";
import Home from "./pages/Home";
import Journeys from "./pages/journeys/Journeys";
import Personas from "./pages/personas/Personas";
import Customers from "./pages/customers/Customers";
import Insights from "./pages/insights/Insights";
import { TimeMachineProvider } from "./contexts/TimeMachineContext";
import { NotificationsProvider } from "./contexts/NotificationsContext";
import { canViewSection, SECTIONS } from "./utils/permissions";

const ProtectedRoute = ({ children, section, showApp }) => {
  const userStatus = useSelector((state) => state.userStatus.value);
  const org = useSelector((state) => state.orgStatus.value);

  // If showApp is false, user is not authenticated (handled by App.js)
  // This shouldn't happen since Main only renders when showApp is true
  if (!showApp) {
    return null;
  }

  // If showApp is true but userStatus is not yet available, show loading state
  // This happens when navigating directly - auth is confirmed but Redux hasn't populated yet
  if (!userStatus || !userStatus.payload) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  try {
    const user = JSON.parse(userStatus.payload);
    const orgId = org?.payload || user.uid;

    if (!canViewSection(user, orgId, section)) {
      // User doesn't have access to this section, redirect to home
      return <Navigate to="/" replace />;
    }

    return children;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return <Navigate to="/" replace />;
  }
};

const Main = (props) => {
  const userStatus = useSelector((state) => state.userStatus.value);
  const userId = userStatus ? JSON.parse(userStatus.payload)?.uid : null;

  return props.showApp ? (
    <TimeMachineProvider>
      <NotificationsProvider userId={userId}>
        <Rail user={props.user} />
        <div className="mainContent">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route 
              path="journeys/*" 
              element={
                <ProtectedRoute section={SECTIONS.JOURNEYS} showApp={props.showApp}>
                  <Journeys />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="personas/*" 
              element={
                <ProtectedRoute section={SECTIONS.PERSONAS} showApp={props.showApp}>
                  <Personas />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="customers/*" 
              element={
                <ProtectedRoute section={SECTIONS.CUSTOMERS} showApp={props.showApp}>
                  <Customers />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="insights/*" 
              element={
                <ProtectedRoute section={SECTIONS.INSIGHTS} showApp={props.showApp}>
                  <Insights />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </NotificationsProvider>
    </TimeMachineProvider>
  ) : null;
};

export default Main;
